import * as v from '@badrap/valita'
import { createStorageCategory } from 'src/storage'

const createLocalStorage = createStorageCategory('local', 'USERS')

export const savedUserFilter = createLocalStorage(
  'filter',
  v.union(v.literal('ALL'), v.literal('CONNECT'), v.literal('COGNITO')),
)

const createSessionStorage = createStorageCategory('session', 'USERS')

export const savedUserQuery = createSessionStorage('query', v.string())
